import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
var AUTHORIZED_USER_IDS = new Set([
    // crqlar demo user in prod
    "6a7c28639c3b6f5f4ecda6b1",
    // FHG
    "66ed55b91c12714d827ec458",
    // KRANZBACH
    "6a7b3b749c3b6f5f4ecd97d0",
    "6a7b3bae9c3b6f5f4ecd97db",
    "6a7b3c999c3b6f5f4ecd97fc",
    "6a7b3cd09c3b6f5f4ecd9805",
    "6a8ed3de6bb68e26ed0fe21c",
    "6a70a0b24186585b41156e3b"
]);
var decodeJwtPayload = function (token) {
    try {
        var payload = token.split(".")[1];
        if (!payload) {
            return null;
        }
        var normalizedPayload = payload
            .replace(/-/g, "+")
            .replace(/_/g, "/")
            .padEnd(Math.ceil(payload.length / 4) * 4, "=");
        return JSON.parse(atob(normalizedPayload));
    }
    catch (_a) {
        return null;
    }
};
/**
 * Reads a single claim from the JWT in localStorage by key. Returns undefined when the token is
 * missing, malformed, or expired, or when the claim is absent / not a string.
 *
 * Frontend counterpart to the backend's generic getClaimFromJwt(token, claim): a claim added to the
 * token's extra claims is read here by key, with no bespoke reader per claim.
 */
var readJwtClaim = function (claim) {
    var token = localStorage.getItem("token");
    if (!token) {
        return undefined;
    }
    var claims = decodeJwtPayload(token);
    if (!claims) {
        return undefined;
    }
    var isExpired = typeof claims.exp === "number" && Date.now() >= claims.exp * 1000;
    if (isExpired) {
        return undefined;
    }
    var value = claims[claim];
    return typeof value === "string" ? value : undefined;
};
/**
 * Subscribes to a single JWT claim, re-reading it on mount, cross-tab storage changes, and window focus.
 */
export var useJwtClaim = function (claim) {
    var _a = useState(function () { return readJwtClaim(claim); }), value = _a[0], setValue = _a[1];
    useEffect(function () {
        var updateClaim = function () {
            setValue(readJwtClaim(claim));
        };
        updateClaim();
        window.addEventListener("storage", updateClaim);
        window.addEventListener("focus", updateClaim);
        return function () {
            window.removeEventListener("storage", updateClaim);
            window.removeEventListener("focus", updateClaim);
        };
    }, [claim]);
    return value;
};
export var useAuthorizedViaAdmin = function () {
    var authorizedBy = useJwtClaim("authorizedBy");
    var userId = useSelector(function (state) { var _a; return (_a = state.auth.user) === null || _a === void 0 ? void 0 : _a.id; });
    // only allow visibility to those insights when:
    // 1) on localhost (dev)
    // 2) when the user has been authorized by an admin (via the "authorizedBy" claim)
    // 3) when the user is one of the known authorized users (by ID)
    return process.env.NODE_ENV === "development"
        || authorizedBy === "admin"
        || (userId != null && AUTHORIZED_USER_IDS.has(userId));
};
